<template>
  <div>
    <NotificationMessage class="notification" />
    <div class="layout mb-5 pr-10">
      <div class="container-1">
        <div class="container-3 pa-2">
          <span class="text-subtitle-1 pl-2">
            {{ $t("crudMyBookings.filters") }}
          </span>
          <div>
            <DateRangeFilter @updateFilter="updateDatesFilter" />
            <ReasonFilter @updateFilter="updateReasonFilter" />
            <v-checkbox
              :label="$t('crudMyBookings.showCancelled')"
              v-model="showCancelled"
              color="red darken-1"
            />
            <ResourcesFilterTreeView
              @updateFilter="updateResourcesFilter"
              :centers="bookings.centers"
              v-if="bookings && bookings.centers.length"
            />
          </div>
        </div>

        <div class="container-2">
          <CrudMyRoomBookings
            class="crud-data-table"
            :bookings="bookings.rooms"
            @cancelBooking="onCancelBooking"
            :showCancelled="showCancelled"
          />
          <CrudMyEquipmentBookings
            class="crud-data-table"
            :bookings="bookings.equipments"
            @cancelBooking="onCancelBooking"
            :showCancelled="showCancelled"
          />
        </div>
      </div>
    </div>

    <v-dialog v-model="isCancelConfirmOpen" width="40%">
      <v-card>
        <v-card-title> {{ $t("myBookings.confirmText") }} </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" text @click="isCancelConfirmOpen = false">
            {{ $t("myBookings.confirmCancel") }}
          </v-btn>
          <v-btn color="red darken-1" text @click="doCancelBooking">
            {{ $t("myBookings.confirmOk") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NotificationMessage from "@/components/components-base/notification/NotificationMessage";
import CrudMyRoomBookings from "@/components/components-salles/public/booking/myBookings/crud/CrudMyRoomBookings";
import CrudMyEquipmentBookings from "@/components/components-salles/public/booking/myBookings/crud/CrudMyEquipmentBookings";
import ResourcesFilterTreeView from "@/components/components-salles/public/booking/myBookings/ResourcesFilterTreeView";
import DateRangeFilter from "@/components/components-salles/public/booking/myBookings/DateRangeFilter";
import ReasonFilter from "@/components/components-salles/public/booking/myBookings/ReasonFilter";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MyBookingsView",
  components: {
    NotificationMessage,
    CrudMyRoomBookings,
    CrudMyEquipmentBookings,
    ResourcesFilterTreeView,
    DateRangeFilter,
    ReasonFilter,
  },
  data: () => ({
    isCancelConfirmOpen: false,
    bookingToCancel: null,
    resourcesFilter: null,
    datesFilter: null,
    reasonFilter: null,
    showCancelled: false,
  }),
  computed: {
    ...mapGetters("userModule", { currentUser: "getCurrentUser" }),
    ...mapGetters("bookingModule", {
      bookingsByUser: "getBookingsByUser",
    }),

    myBookings() {
      return this.bookingsByUser(this.currentUser);
    },
    bookings() {
      const bookings = {
        rooms: [],
        equipments: [],
        centers: new Set(),
      };

      for (const booking of this.myBookings) {
        bookings.centers.add(booking.center);

        if (
          booking.cancelled == this.showCancelled &&
          !this.filtered(booking)
        ) {
          if (booking.resources.find((x) => x.type === "room"))
            bookings.rooms.push(booking);
          else bookings.equipments.push(booking);
        }
      }

      bookings.centers = Array.from(bookings.centers);
      return bookings;
    },
  },
  methods: {
    ...mapActions("bookingModule", [
      "loadBookingsWithDependents",
      "cancelBooking",
      "rebuildTimeslotsCache",
    ]),

    onCancelBooking(booking) {
      this.isCancelConfirmOpen = true;
      this.bookingToCancel = booking;
    },
    async doCancelBooking() {
      this.isCancelConfirmOpen = false;
      await this.cancelBooking(this.bookingToCancel);
      this.rebuildTimeslotsCache();
    },
    updateResourcesFilter(newResourcesFilter) {
      this.resourcesFilter = newResourcesFilter;
    },
    updateDatesFilter(newInterval) {
      this.datesFilter = newInterval;
    },
    updateReasonFilter(newReason) {
      this.reasonFilter = newReason;
    },
    filtered(booking) {
      return !(
        ((this.resourcesFilter?.centers.has(booking.center) &&
          booking.resources.some((x) =>
            this.resourcesFilter.resources.has(x)
          )) ||
          !this.resourcesFilter) &&
        (this.datesFilter?.overlaps(booking.interval) || !this.datesFilter) &&
        (booking.reason == this.reasonFilter || !this.reasonFilter)
      );
    },
  },
  async mounted() {
    await this.loadBookingsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: absolute;
  padding: 0 1.5rem;
  z-index: 100;
}

.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.crud-data-table {
  margin: 10px auto;
  width: 98%;
}

.container-1 {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.container-2 {
  display: flex;
  flex-direction: column;
  background-color: #eeeeee;
  border-radius: 10px;
  margin-left: 5px;
  width: 100%;
  border: 1px solid #dfdfdf;
}

.container-3 {
  width: 275px;
  min-width: 275px;
  background-color: #eeeeee;
  border-radius: 10px;
  border: 1px solid #dfdfdf;
}
</style>
